import React from 'react';
import PropTypes from "prop-types";

function LoadingSpinner(props) {
    return (
        <div className="loadingSpinner">
            <div className="double-bounce1" />
            <div className="double-bounce2" />
        </div>
    );
}

LoadingSpinner.propTypes = {
    title: PropTypes.string.isRequired,
};

export default LoadingSpinner;
